import { useState } from "react";
import { Avatar, Card, List, Space, Badge, Switch } from "antd";
import { useLocation } from "react-router";

// Components
import RemarkTextArea from "../RemarkTextArea";
import { ButtonLink } from "../../../../components";

import { ROUTES, COMMON_FEATURES } from "../../../../constants";

// Styles
import classStyles from "../../index.module.css";

const { MODULE_ROUTE } = ROUTES;
const { COMPANY_LIST, EMPLOYER } = COMMON_FEATURES.FEATURE_NAME;

const RemarkLists = ({
  dataSource,
  user,
  setIndex,
  setEdit,
  setEditValue,
  setShowEditTextArea,
  setRecord,
  messageApi,
  deleteRemarkHDLR,
  handleHide,
  TIME,
  edit,
  index,
  showEditTextArea,
  editValue,
  handleOkButton,
  loading,
  statusData,
}) => {
  const sortedData = dataSource.sort(
    (a, b) => (a?.ref_status ? 1 : -1) - (b?.ref_status ? 1 : -1)
  );

  const location = useLocation();
  const { pathname = "" } = location;

  return (
    <List
      loading={loading}
      itemLayout="horizontal"
      dataSource={sortedData}
      renderItem={(cel, i) => {
        const { createdAt, createdBy, ref_status, status} = cel;
        const enable = status === 2;
        const Title = () => {
          const refStatus = !ref_status || ref_status === null ? 1 : ref_status;
          let name, colorTag, bgColor;
          if (statusData[refStatus]) {
            ({ name, colorTag, bgColor } = statusData[refStatus]);
          }
          const header =
            createdBy === "system" ? createdBy : `${cel?.name || "-"} /${createdBy}`;
          return (
            <div>
              {!cel?.ref_status ? (
                <Space>
                  <Avatar />
                  <div>
                    <p>{createdBy}</p>
                    <p style={{ fontWeight: "300" }}>
                      Update at {TIME.parseTimeMin(createdAt)}
                    </p>
                  </div>
                </Space>
              ) : (
                <div className={classStyles["list-header"]}>
                  <Space>
                    <Avatar />
                    <div>
                      <p>{header}</p>
                      <p style={{ fontWeight: "300" }}>
                        Update at {TIME.parseTimeMin(createdAt)}
                      </p>
                    </div>
                  </Space>
                  <div
                    style={{
                      backgroundColor: bgColor,
                      display: "inline-block",
                      padding: "3px 13px",
                      borderRadius: "30px",
                      // width: "100px",
                    }}
                  >
                    <Badge
                      color={colorTag}
                      text={<span style={{ color: colorTag }}>{name}</span>}
                    />
                  </div>
                </div>
              )}
            </div>
          );
        };

        const Description = () => {
          const getRelevantAttachment = (cel) => {
            const attachments = cel?.attachment;
            if (!attachments || attachments.length === 0) {
              return null; // or handle no attachments case
            }
            const attachmentCount = attachments.length;
            if (attachmentCount === 1) {
              return attachments[0];
            }
            // When there are more than one attachment
            return attachments[attachmentCount - 2];
          };

          const excelFile = getRelevantAttachment(cel);

          const handleButtonClick = () => {
            window.open(excelFile?.url, "_blank");
          };

          return (
            <>
              <div>
                <Card className={classStyles["card-remark"]}>
                  {cel?.msg} <br /> <br />
                  <ButtonLink onClick={handleButtonClick}>
                    {excelFile?.name}
                  </ButtonLink>
                </Card>
                {!cel?.ref_status ? (
                  <div>
                    <div style={{ display: "inline-flex" }}>
                      <ButtonLink
                        className={classStyles["icons"]}
                        onClick={() => {
                          setIndex(i);
                          setEdit(true);
                          setEditValue(cel?.msg);
                          setShowEditTextArea(true);
                          setRecord(cel);
                        }}
                      >
                        Edit
                      </ButtonLink>
                      <span style={{ marginRight: "8px" }}>|</span>
                      <ButtonLink
                        className={classStyles["icons"]}
                        onClick={() => {
                          messageApi.open({
                            type: "loading",
                            content: "Deleting remark...",
                            duration: 0,
                          });
                          deleteRemarkHDLR(cel?.remid, () =>
                            messageApi.destroy()
                          );
                        }}
                      >
                        Delete
                      </ButtonLink>
                    </div>
                  </div>
                ) : (
                  <div>
                    {user.uroleid === "A" &&
                      pathname !== MODULE_ROUTE[COMPANY_LIST] &&
                      pathname !== MODULE_ROUTE[EMPLOYER] && (
                        <p style={{ fontSize: "12px" }}>
                          <span style={{ marginRight: "8px" }}>
                            Hide from customer
                          </span>
                          <Switch
                            style={{
                              "--before-color": enable ? "#0E2483" : "gray",
                              "--height": "5px",
                              "--top": "-9px",
                              "--bg-before-color": "gray"
                            }}
                            checked={enable}
                            onChange={(e) => {
                              handleHide(e, cel);
                            }}
                          />
                        </p>
                      )}
                  </div>
                )}
              </div>
            </>
          );
        };

        return (
          <>
            {edit && i === index && showEditTextArea ? (
              <RemarkTextArea
                value={editValue}
                setValue={setEditValue}
                handleOkButton={handleOkButton}
                setShowTextArea={setShowEditTextArea}
              />
            ) : (
              <List.Item style={{ padding: "30px 0", borderTop: "1px solid gray" }}>
                <List.Item.Meta
                  title={<Title />}
                  description={<Description />}
                />
              </List.Item>
            )}
          </>
        );
      }}
    />
  );
};

export default RemarkLists;
